import {GET_TEST_MESSAGE_START, GET_TEST_MESSAGE} from "./AppActions";

const INITIAL_STATE = {
  page: '',
  snackBar: '',
  loading: false,
  loadingBackDrop: false,
  leftDrawer: false,
  enablePremium: false,
  enableDomainSSO: false,
  mainElement: null,
  env: '',
  stripe: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_TEST_MESSAGE_START:
      return {...state, testFetching: true};
    case GET_TEST_MESSAGE:
      if (action.error) {
        return {...state, error: action.payload.message, testFetching: false};
      }
      return {...state, ...action.payload.data, fetching: false};
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/containers/app/AppReducer.js